export default {
    list: [{
            label: "Clientes",
            route: "",
            items: [{
                    label: "Visualizar",
                    route: "admin.clients"
                },
                {
                    label: "Consultorias",
                    route: "admin.consultings"
                }
            ],
            active: false
        },
        {
            label: "Legislação",
            route: "",
            items: [{
                    label: "Visualizar",
                    route: "admin.legislations"
                },
                {
                    label: "Categorias",
                    route: "admin.legislation-categories"
                }
            ],
            active: false
        },
        {
            label: "Índices",
            route: "admin.indices",
            items: [],
            active: false
        },
        {
            label: "Conteúdo",
            route: "",
            items: [{
                    label: "Textos",
                    route: "admin.texts"
                },
                {
                    label: "Revistas",
                    route: "admin.magazines"
                },
                {
                    label: "Edições de Revistas",
                    route: "admin.editions"
                },
                {
                    label: "Autores",
                    route: "admin.authors"
                },
                {
                    label: "Cursos",
                    route: "admin.courses"
                },
                {
                    label: "Vídeo Aulas",
                    route: "admin.video-lessons"
                },
                {
                    label: "Certidões",
                    route: "admin.certificates"
                },
                {
                    label: "Súmulas",
                    route: "admin.summaries"
                },
            ],
            active: false
        },
        {
            label: "Produtos",
            route: "admin.products",
            items: [],
            active: false
        },
        {
            label: "Comunicação",
            route: "",
            items: [{
                    label: "Notícias",
                    route: "admin.list-news"
                },
                {
                    label: "Newsletter",
                    route: "admin.newsletters"
                },
                {
                    label: "Conteúdo das páginas",
                    route: "admin.pages"
                }
            ],
            active: false
        },
        {
            label: "Relatórios",
            route: "",
            items: [{
                    label: "Ranking de acessos",
                    route: "admin.report-text-access"
                },
                {
                    label: "Textos Acessados",
                    route: "admin.report-daily-text-access"
                },
                {
                    label: "Visitas ao Site",
                    route: "admin.report-system-access"
                }
            ],
            active: false
        },
        {
            label: "Sistema",
            route: "",
            items: [{
                    label: "Usuários",
                    route: "admin.users"
                },
                {
                    label: "Notificações",
                    route: "admin.notifications"
                },
                {
                    label: "Vendas online",
                    route: "",
                },
                {
                    label: "Pacotes",
                    route: "admin.packages",
                },
                {
                    label: "Banco de Imagens",
                    route: "admin.images",
                },
                {
                    label: "Parâmetros do sistema",
                    route: "admin.system_parameters"
                },
                {
                    label: "Avisos Agendados",
                    route: "admin.banners"
                },
                {
                    label: "Erros e Melhorias",
                    route: "admin.errors",
                },
            ],
            active: false
        }
    ]
}